import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'
import { FormContext, useForm } from 'react-hook-form'
import { Box, Button, Tooltip } from '@material-ui/core'
import { reverse } from 'named-urls'
import { HelpCircle as HelpCircleIcon } from 'react-feather'

import {
  Container,
  ContentHeader,
  DriveTour,
  LoadingFeedback,
  Page,
} from 'components'
import { PrivacyByDesignForm } from './components'

import useSnackbar from 'hooks/useSnackbar'

import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'
import schema from './components/PrivacyByDesignForm/schema'
import {
  buildCreatePayload,
  buildDefaultValues,
} from './components/PrivacyByDesignForm/formMappers'

const PrivacyByDesignNew = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [openTour, setOpenTour] = useState(false)

  const history = useHistory()
  const snackbar = useSnackbar()

  const {
    NEW_PRIVACY_BY_DESIGN_FORM_DRIVER_STEPS_OBJECT,
    PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_0,
    PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1,
    PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2,
  } = constants.privacyByDesign

  const formMethods = useForm({
    validationSchema: schema({ mode: 'new' }),
    defaultValues: buildDefaultValues(null, { mode: 'new' }),
  })

  const onSubmit = async (values) => {
    setIsLoading(true)

    try {
      const response = await service.dponet.privacyByDesign.create(
        buildCreatePayload(values),
      )

      const privacyByDesign = response?.data?.privacyByDesign

      history.push(
        reverse(routes.privacyByDesign.edit, {
          privacyByDesignId: privacyByDesign?.id,
        }),
      )
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao criar o projeto.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleOpenTour = () => {
    helpers.mixpanel.track('Privacy By Design', 'Tour', {
      action: 'tour-privacy-by-design',
    })
    setOpenTour(true)
  }

  return (
    <Page title="Criação de Projeto - Privacy By Design">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Privacy By Design">
          <Tooltip title="Iniciar o tour guiado">
            <Button
              id={PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_0}
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={handleOpenTour}
              fullWidth
            >
              Tutorial
            </Button>
          </Tooltip>
        </ContentHeader>
        <FormContext {...formMethods}>
          <PrivacyByDesignForm
            mode="new"
            onSubmit={onSubmit}
            departmentsService={service.dponet.privacyByDesign.getDepartments}
            usersService={service.dponet.privacyByDesign.getUsers}
            quizTemplatesService={
              service.dponet.privacyByDesign.listQuizTemplates
            }
            cardId={PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1}
          />
        </FormContext>
        <Box ml={2} mt={2} display="flex" justifyContent="flex-end">
          <Box pr={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => history.push(routes.privacyByDesign.all)}
            >
              Cancelar
            </Button>
          </Box>
          <Box>
            <Button
              form="privacy-by-design-form"
              type="submit"
              color="primary"
              variant="contained"
              id={PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2}
            >
              Criar
            </Button>
          </Box>
        </Box>
      </Container>
      <DriveTour
        stepsMatrix={NEW_PRIVACY_BY_DESIGN_FORM_DRIVER_STEPS_OBJECT}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default PrivacyByDesignNew
